// extracted by mini-css-extract-plugin
export default {"callout":"CalloutNodeView_callout__793Jm"};